import { useGetQuery } from "hooks";
import { useEffect } from "react";
import { Box } from "../box";
import { getPanelConfigSchema, resolveConfig } from "../panel-config";
import { usePanelLocation } from "../use-panel-location";
import { Current, Temp, Forecast, Day, Max, Empty } from "./styles";

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const Weather = ({ details }) => {
  const config = resolveConfig(getPanelConfigSchema("weather"), details?.config);
  const geo = usePanelLocation(config);

  const { data, reFetch, setEnabled, setPath } = useGetQuery({
    enabled: geo?.latitude,
    url: `/weather/${geo.latitude}/${geo.longitude}`,
  });

  useEffect(() => {
    setEnabled(true);
    setPath(`/weather/${geo.latitude}/${geo.longitude}`);
    reFetch();
  }, [geo.latitude, geo.longitude, setPath, reFetch]);

  // API returns { error } (or nothing) when the forecast is unavailable
  if (data && !data.current) {
    return (
      <Box>
        <Empty>Weather unavailable</Empty>
      </Box>
    );
  }

  return (
    <Box>
      <Current>
        <img
          src={`https://openweathermap.org/img/wn/${data?.current?.weather[0]?.icon}@2x.png`}
        />
        <Temp>{parseInt(data?.current?.temp)}°</Temp>
      </Current>
      <Forecast>
        {data?.daily?.map((day, i) => {
          if (i >= 5 || i === 0) return null;
          return (
            <Day key={day.dt}>
              {MONTHS[new Date(day.dt * 1000).getMonth()]}{" "}
              {new Date(day.dt * 1000).getDate()}
              <img
                src={`https://openweathermap.org/img/wn/${day.weather[0]?.icon}.png`}
              />
              <div>
                <Max>{parseInt(day?.temp?.max)}/</Max>
                {parseInt(day?.temp?.min)}
              </div>
            </Day>
          );
        })}
      </Forecast>
    </Box>
  );
};
